import { isSSR } from './isSSR';

export const isStaging = () => {
  if (!isSSR) {
    const { hostname } = window.location;
    return Boolean(hostname === 'staging');
  }
};
